"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Drawer_1 = __importDefault(require("@mui/material/Drawer"));
var react_1 = __importDefault(require("react"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var KeyboardArrowRight_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRight"));
var KeyboardArrowLeft_1 = __importDefault(require("@mui/icons-material/KeyboardArrowLeft"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var realcity_logo_small_svg_1 = __importDefault(require("../../../images/realcity_logo_small.svg"));
var realcity_logo_big_svg_1 = __importDefault(require("../../../images/realcity_logo_big.svg"));
var SidebarBody_1 = __importDefault(require("./SidebarBody"));
var useStyles = (0, makeStyles_1.default)(function (theme) {
    var _a;
    return ({
        paper: {
            overflow: 'hidden',
            zIndex: 1000,
            position: 'absolute',
            height: 'inherit',
            bottom: 0,
            right: 0,
        },
        root: (_a = {
                position: 'relative'
            },
            _a[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _a.transition = 'width 0.15s ease-out',
            _a.width = function (_a) {
                var expanded = _a.expanded;
                return expanded ? 285 : 56;
            },
            _a),
        divider: {
            margin: '12px 8px',
        },
        button: {
            display: 'flex',
            minWidth: 0,
            margin: '0 8px 12px auto',
        },
    });
});
var PermanentSidebar = function (_a) {
    var expanded = _a.expanded, onToggle = _a.onToggle, children = _a.children, rest = __rest(_a, ["expanded", "onToggle", "children"]);
    var classes = useStyles({ expanded: expanded });
    var drawerClasses = {
        paper: classes.paper,
        root: classes.root,
    };
    return (react_1.default.createElement(Drawer_1.default, __assign({ variant: "permanent", classes: drawerClasses }, rest),
        react_1.default.createElement(SidebarBody_1.default, { logo: expanded ? realcity_logo_big_svg_1.default : realcity_logo_small_svg_1.default }, children),
        onToggle && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Divider_1.default, { className: classes.divider }),
            react_1.default.createElement(Button_1.default, { className: classes.button, onClick: onToggle, variant: "text" }, expanded ? react_1.default.createElement(KeyboardArrowLeft_1.default, null) : react_1.default.createElement(KeyboardArrowRight_1.default, null))))));
};
exports.default = PermanentSidebar;
